class ValidationMessage {
    constructor() {
        this.messages = {
            0: "Error validación documento",
            1: "Número de document ok",
            '-1': "Lletra del NIF incorrecta",
            3: "Número de document ok",
            '-3': "Lletra del NIE incorrecta"
        };
    }

    getMessage(id) {
        return this.messages[id] || "Mensaje no definido para este ID";
    }
}

export default ValidationMessage;